module.exports = __webpack_public_path__ + "static/media/truck-schedule-1.9dbcd22d.jpg";